import { render, staticRenderFns } from "./MainCategoryNavBar.vue?vue&type=template&id=27aefa64&scoped=true"
import script from "./MainCategoryNavBar.vue?vue&type=script&lang=js"
export * from "./MainCategoryNavBar.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryNavBar.vue?vue&type=style&index=0&id=27aefa64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aefa64",
  null
  
)

export default component.exports